import Sidebar from "../components/StudentSidebar";
import { useState, useEffect } from "react";
import axios from "axios";
import "../styles/StudentTasks.css";
import { parseISO, format, isToday, isPast, endOfDay } from 'date-fns';
import { pl } from 'date-fns/locale';
import { extractErrorMessage } from '../utils/errorUtils';

export default function StudentTasks() {
    // State to hold student tasks
    const [tasks, setTasks] = useState([]);
    // State to load student tasks
    const [loadingTasks, setLoadingTasks] = useState(true);
    // Add file and modal states
    const [showModal, setShowModal] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);
    const [file, setFile] = useState(null);

    // Fetch student tasks
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/tasks/studentTasks`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(response => {
            setTasks(response.data);
            setLoadingTasks(false);
        })
        .catch(error => {
            console.error('Error fetching student tasks:', error);
            setLoadingTasks(false);
        });
    }, []);

    // Helper function to last date to add task
    const getTaskClass = (dueDate, isSubmitted) => {
        if (!dueDate) return "";
        const parsedDate = parseISO(dueDate);

        if (!isSubmitted && isToday(parsedDate)) {
            return "student-task-warning";
        }
        if (!isSubmitted && isPast(endOfDay(parsedDate))) {
            return "student-task-alert";
        }
        return "";
    };

    // Upload file handler
    const handleUpload = async () => {
        if (!file || !selectedTask) {
            alert("Wybierz plik do przesłania");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/tasks/assignment/${selectedTask.assignment_id}/upload`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            alert(response.data.message || "Plik został przesłany!");
            setShowModal(false);
            setFile(null);
            // Refresh tasks list
            window.location.reload();
        } catch (err) {
            console.error("Błąd uploadu:", err);
            const errorMessage = extractErrorMessage(err) || "Nie udało się przesłać pliku";
            alert(errorMessage);
        }
    };

    return (
        <div className="student-dashboard-panel">
            {/* Sidebar */}
            <Sidebar />
            {/* Main Content */}
            <div className='main-content'>
                {/* Header */}
                <div className='header'>
                    <h1 className='header-title'>Zadania</h1>
                </div>
                {/* Dashboard Content */}
                <div className="dashboard">
                    <div className='student-header'>
                        <h1 className='student-title'>Zadania</h1>
                        <p className="student-subheading">Przeglądaj i zarządzaj swoimi zadaniami</p>
                    </div>
                    {/* Tasks List */}
                    {loadingTasks ? (
                        <p>Ładowanie zadań...</p>
                    ) : tasks.length === 0 ? (
                        <p>Brak zadań do wyświetlenia.</p>
                    ) : (
                        <div className="student-tasks-grid">
                            {tasks.map(task => (
                                <div
                                    key={task.assignment_id}
                                    className={`student-task-card ${getTaskClass(task.due_date, task.is_submitted)}`}
                                >
                                    <h2 className="student-task-title">{task.assignment_title}</h2>
                                    <p className="student-task-desc">{task.assignment_description || "Brak opisu"}</p>
                                    <p className="student-task-info"><strong>Przedmiot:</strong> {task.module_name}</p>
                                    <p className="student-task-info"><strong>Wykładowca:</strong> {task.lecturer_name} ({task.lecturer_email})</p>
                                    <p className="student-task-info">
                                        <strong>Termin:</strong> 
                                        {task.due_date
                                        ? format(parseISO(task.due_date), ' dd.MM.yyyy', { locale: pl })
                                        : 'Brak daty urodzenia'}
                                    </p>
                                    <p className="student-task-info"><strong>Status:</strong> {task.is_submitted ? "Oddane" : "Nieoddane/Niesprawdzone"}</p>
                                    {task.student_grade && (
                                        <p className="student-task-info"><strong>Ocena:</strong> {task.student_grade}</p>
                                    )}
                                    <div className="student-task-actions">
                                        <button 
                                            className="student-task-submit-btn"
                                            onClick={() => {
                                                setSelectedTask(task);
                                                setShowModal(true);
                                            }}
                                        >
                                            Oddaj zadanie
                                    </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            {showModal && (
                <div className="add-task-modal-overlay">
                    <div className="add-task-modal">
                        <h2>Prześlij plik</h2>
                        <p>Nazwa zadania: {selectedTask.assignment_title}</p>
                        <label className="file-upload-btn">
                            <input 
                                type="file" 
                                onChange={(e) => setFile(e.target.files[0])}
                                className="file-input-hidden"
                            />
                            Wybierz plik
                        </label>
                        {file && (
                            <p className="file-chosen">Wybrano: {file.name}</p>
                        )}
                        <div className="task-modal-actions">
                            <button onClick={handleUpload} className="task-button lecturer-task-edit">Wyślij</button>
                            <button onClick={() => setShowModal(false)} className="task-button btn-edit-task-secondary">Anuluj</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}